import React, { useEffect, useState } from 'react';
import S from './DateOnlyInput.module.scss';

interface Argument {
  valeurParDefaut?: string;
  value?: string;
  obligatoire?: boolean;
  nom?: string;
  type: 'DateOnly' | 'DateTime';
}

interface Props {
  argument: Argument;
  onChange: (field: string, value: string) => void;
}

const DateInput: React.FC<Props> = ({ argument, onChange }) => {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('00:00');

  useEffect(() => {
    const initialValue = argument.valeurParDefaut || argument.value || '';
    if (argument.type === 'DateTime') {
      // Format attendu: "YYYY-MM-DD HH:mm" ou JSON { date, time }
      try {
        let parsed: any = initialValue;
        if (typeof initialValue === 'string') {
          if (initialValue.includes(' ')) {
            const [d, t] = initialValue.split(' ');
            setDate(d);
            setTime(t || '00:00');
            return;
          }
          parsed = JSON.parse(initialValue);
        }
        if (parsed.date) setDate(parsed.date);
        if (parsed.time) setTime(parsed.time);
      } catch {
        setDate(initialValue);
        setTime('00:00');
      }
    } else {
      setDate(initialValue);
    }
  }, [argument.valeurParDefaut, argument.value, argument.type]);

  const handleDateChange = (value: string) => {
    setDate(value);
    if (argument.type === 'DateTime') {
      onChange('valeurParDefaut', JSON.stringify({ date: value, time }));
    } else {
      onChange('valeurParDefaut', value);
    }
  };

  const handleTimeChange = (value: string) => {
    setTime(value);
    onChange('valeurParDefaut', JSON.stringify({ date, time: value }));
  };

  // Format jj/mm/aaaa
  const formatDateDisplay = (dateStr: string) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };

  const isDateTime = argument.type === 'DateTime';

  return (
    <div className={S.dateTimeContainer}>
      <div className={S.dateInputs}>
        <div className={S.inputGroup}>
          <label className={S.label}>Date{argument.obligatoire && ' *'}</label>
          <input
            type="date"
            value={date}
            onChange={(e) => handleDateChange(e.target.value)}
            className={S.dateInput}
            required={argument.obligatoire}
          />
        </div>
        {isDateTime && (
          <div className={S.inputGroup}>
            <label className={S.label}>
              Heure{argument.obligatoire && ' *'}
            </label>
            <input
              type="time"
              value={time}
              onChange={(e) => handleTimeChange(e.target.value)}
              className={S.timeInput}
              required={argument.obligatoire}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateInput;
